// Typelizer digest b724f875f8bf3227426627141e2f0b9c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** DELETE /mobile_devices/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/mobile_devices/:id', params, options),
    method: 'delete',
  }),
}
